import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-header left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex pb-4" }
const _hoisted_4 = { class: "mr-2 w-1/3" }
const _hoisted_5 = { class: "ml-2 w-2/3" }
const _hoisted_6 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_7 = { class: "text-2xl capitalize" }
const _hoisted_8 = { class: "px-4 py-6 overflow-y-auto scroll-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_ButtonSecondary = _resolveComponent("ButtonSecondary")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderShadow),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addSession && _ctx.addSession(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/local-admin/sessions" }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonSecondary, {
                  type: "button",
                  name: _ctx.$t('buttons.cancel'),
                  disabled: _ctx.loading
                }, null, 8, ["name", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              type: "submit",
              name: _ctx.$t('buttons.addSession'),
              disabled: 
                !_ctx.required(_ctx.session.name) || !_ctx.required(_ctx.session.roomId) || _ctx.loading
              ,
              loading: _ctx.loading
            }, null, 8, ["name", "disabled", "loading"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-nucleus-white transition-all", { 'opacity-50': _ctx.loading }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-session" }, null, -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("global.defaults.newSession")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Input, {
              id: "name",
              value: _ctx.session.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.session.name) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.name.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.name.placeholder'),
              autocomplete: "off",
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Select, {
              id: "ors",
              value: _ctx.session.roomId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.session.roomId) = $event)),
              label: _ctx.$t('inputs.room.label'),
              options: _ctx.operatingRooms,
              required: ""
            }, null, 8, ["value", "label", "options"]),
            _createVNode(_component_Input, {
              id: "department",
              value: _ctx.session.department,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.session.department) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.department.label'),
              icon: "",
              "max-length": _ctx.inputMaxLengths.department,
              placeholder: _ctx.$t('inputs.department.placeholder'),
              autocomplete: "off"
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Textarea, {
              id: "notes",
              value: _ctx.session.notes,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.session.notes) = $event)),
              label: _ctx.$t('inputs.notes.label'),
              "max-length": _ctx.inputMaxLengths.notes,
              placeholder: _ctx.$t('inputs.notes.placeholder')
            }, null, 8, ["value", "label", "max-length", "placeholder"])
          ])
        ], 2)
      ], 32),
      (_ctx.errorHeading || _ctx.errorContent)
        ? (_openBlock(), _createBlock(_component_ErrorBox, {
            key: 0,
            heading: _ctx.errorHeading,
            content: _ctx.errorContent,
            fixed: _ctx.errorFixed,
            onCloseError: _cache[5] || (_cache[5] = ($event: any) => {
          _ctx.errorHeading = '';
          _ctx.errorContent = '';
        })
          }, null, 8, ["heading", "content", "fixed"]))
        : _createCommentVNode("", true)
    ])
  ]))
}